import {allergensIcons} from "../../resources/images/allergensIcons";
import {Stack, useTheme} from "@mui/material";

const AllergensList = props => {
    const {palette} = useTheme();
    const {allergens} = props;

    const allergensList = allergens.map(algn => {
        const Allergen = allergensIcons.find(ai => ai.uid === algn).icon;

        return <Allergen key={algn} width={16} height={16} color={palette.secondary.main} style={{fill: 'currentColor'}} />
    })

    return <Stack direction='row' ml={2} gap="3px">
        {allergensList}
    </Stack>
}

export default AllergensList;